import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-zinc-800 via-zinc-700 to-zinc-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center space-x-2 mb-3">
              <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
                <i className="ri-road-map-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-black" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                LINCOLN PAVING
              </span>
            </div>
            <p className="text-zinc-300 mb-3 leading-relaxed text-sm">
              Lincoln's premier asphalt and concrete paving contractor. Quality workmanship, competitive pricing, and exceptional customer service since 2008.
            </p>
            <div className="flex space-x-2">
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-bold mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-bold mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Our Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/asphalt-repair" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Asphalt Repair
                </Link>
              </li>
              <li>
                <Link to="/services/concrete-driveway" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Concrete Driveway
                </Link>
              </li>
              <li>
                <Link to="/services/sealcoating" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Sealcoating
                </Link>
              </li>
              <li>
                <Link to="/services/parking-lot" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Parking Lot Paving
                </Link>
              </li>
              <li>
                <Link to="/services/commercial-asphalt" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  Commercial Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base font-bold mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Contact Us</h4>
            <ul className="space-y-2">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                <span className="text-zinc-300 text-sm">123 Paving Way<br />Lincoln, NE 68508</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-lg mr-2 flex-shrink-0"></i>
                <a href="tel:3084705637" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm">
                  (308) 470-5637
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-lg mr-2 flex-shrink-0"></i>
                <a href="mailto:info@lincolnpaving.com" className="text-zinc-300 hover:text-white transition-colors cursor-pointer text-sm break-all">
                  info@lincolnpaving.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-time-line text-lg mr-2 mt-0.5 flex-shrink-0"></i>
                <span className="text-zinc-300 text-sm">Mon-Fri: 7am-6pm<br />Sat: 8am-4pm</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-600/40 mt-6 sm:mt-8 pt-5 sm:pt-6 flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
          <p className="text-zinc-400 text-xs text-center sm:text-left">
            © 2024 Lincoln Paving. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center sm:justify-end items-center gap-4 text-xs">
            <Link to="/privacy-policy" className="text-zinc-400 hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-white transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}